module.exports = __webpack_public_path__ + "static/media/img_konfirmasiakun.43bbc28a.svg";